import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";

export class SponsorshipsRequestParams extends BaseApiRequestParams {}
